import React from 'react';
import { navigate } from "gatsby";
import { default as worldMap } from '../../../images/eco-product-2.svg';
import { default as ecoAllianceBadge } from '../../../images/Eco-A.gif';
import { default as CO2 } from '../../../images/eco-alliance-co2.svg';
import {default as treePlant} from '../../../images/eco-alliance-plant.svg'
import Button from '../Button/Button';
import CommunityImg from '../CommunityImg/CommunityImg';
import './SustainabilityCommunity.scss';

const SustainabilityCommunity = ({
  tab,
  colorCode
}) => {
  const imgURL = (tab === 'Community') ? ecoAllianceBadge : worldMap ;
  const heading = (tab === 'Community') ? `Our Eco-Alliance Community `: `We're committed to working with suppliers that meet our quality, sustainability and fair treatment standards.`;
  const subheading =
    tab === "Community" ? (
      `Our community of Eco-Alliance members share our passion and commitment to sustainable packaging. Makers, Businesses, and Brands of all sizes take part in our member initiatives like reforestation, member stories, and resources to help us achieve more, together! Find out more and join the businesses leading the way in sustainable packaging for their industries.`
    ) : (
      <>
        {`Our manufacturing and distribution locations are based all over the world. This helps us deliver the best quality products that are customizable (where applicable), at low minimum order quantities. Dependent on the product and quantity of your order, your product will be made and shipped from a location that best allows us to fulfill the order in a timely manner. We have `}{" "}
        <a href="https://noissue.co/blog/health-safety-wellbeing-supply-chain/" target="_blank" rel="noopener noreferrer">
          world-class supply and distribution partners
        </a>{" "}
        {`that prioritize sustainable materials and health, safety, and wellbeing. We're also proud to offer `}{" "}
        <a href="https://noissue.co.nz/blog/noissues-journey-to-carbon-neutral/" target="_blank" rel="noopener noreferrer">
          Carbon Neutral
        </a>
        {` Shipping for your Packages!`}
      </>
    )
  const linkURL = (tab === 'Community') ? `https://noissue.co/community/eco-alliance/` : `https://noissue.co/blog/health-safety-wellbeing-supply-chain/`;
  const openURL = url => window.open(url, '_self', 'noopener');

  return (
    <div className="sustainability-community" style={{boxShadow : `10px 10px 0px ${colorCode}`}}>
      <div className="main-section">
        <div className="left-section">
          <CommunityImg className={tab === 'Community' ? 'community-image' : ''} src={imgURL} alt="image" />
        </div>
        <div className="right-section">
          <div className="heading" style={{color : colorCode}}> {heading} </div>
          <div className="subheading"> {subheading} </div>
          <Button cls="sustainability-community-btn" onClick={() => openURL(linkURL)} bgColor={colorCode} label="Read More" />
        </div>
      </div>
      {
        tab === 'Community' && 
          <div className="sustainability-community-details">
            <div className="items">
              <CommunityImg src={treePlant} alt="tree plant"/>
              <div className="details">
                <div className="heading" style={{color : colorCode}}>26,986</div>
                <div className="subheading">trees planted worldwide</div>
              </div>
            </div>
            <div className="items">
              <CommunityImg src={CO2} alt="tree plant"/>
              <div className="details">
                <div className="heading" style={{color : colorCode}}>876.56T</div>
                <div className="subheading">of carbon reduction</div>
              </div>
            </div>
          </div>
      }
    </div>
  )
}

export default SustainabilityCommunity; 